export const MAX_FILTER_COUNT = 5
export const SSR_CAROUSEL_ITEM_COUNT = 3
export const SSR_CAROUSEL_SHOW_MORE_ITEM_COUNT = 8
export const MAX_CAROUSEL_ITEM_COUNT = 20
